module.exports = __webpack_public_path__ + "static/media/driverIcon.789b7b8b.svg";